import request from 'services/request';

export async function productsMassiveUpload({ cancelToken, data }) {
  let uri = `/Catalogs/Api/v1/products/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,

    data,
  });
}
